import * as yup from 'yup';
import set from 'lodash/set';
import { toast } from 'react-toastify';

const parseErrors = (err) => {
  const error = {};
  err.inner.forEach((item) => {
    set(error, item.path, item.message);
  });

  return error;
};

class BaseModel {
  requiredText = 'Pole jest wymagane';

  yup = yup;

  data = {};

  constructor(model) {
    Object.keys(model || {}).forEach((key) => {
      this.data[key] = model[key];
    });
  }

  validate() {
    try {
      const schema = yup.object().shape(this.schema);
      let finalData = this.data;

      if (this.getData) {
        finalData = this.getData();
      }

      schema.validateSync(finalData, {
        abortEarly: false,
      });

      return false;
    } catch (err) {
      toast.error('Ups błąd walidacji. Popraw dane na formularzu.');
      return parseErrors(err);
    }
  }
}

export default BaseModel;
